import '@hotwired/turbo'
import { Application } from '@hotwired/stimulus'
import { definitionsFromContext } from '@hotwired/stimulus-webpack-helpers'
import Lenis from 'lenis';

// Start Stimulus application
const application = Application.start()
const context = require.context('./controllers', true, /\.js$/)
application.load(definitionsFromContext(context));
application.debug = process.env.NODE_ENV === 'development';

import './css/app.scss';

// Automatically add all images to the manifest.json
const imagesCtx = require.context('./images', false, /\.(png|jpg|jpeg|gif|ico|svg|webp)$/);
imagesCtx.keys().forEach(imagesCtx);

// Always break out of a missing frame
document.documentElement.addEventListener('turbo:frame-missing', (e) => {
    e.preventDefault();
    e.detail.visit(e.detail.response);
});

// scrollbarWidth.js
const calculateScrollbarWidth = (function calculateScrollbarWidth() {
    document.documentElement.style.setProperty('--scrollbar-width', (window.innerWidth - document.documentElement.clientWidth) + 'px');

    return calculateScrollbarWidth;
})();

document.addEventListener('DOMContentLoaded', calculateScrollbarWidth); 
window.addEventListener('resize', calculateScrollbarWidth);
window.addEventListener('load', calculateScrollbarWidth);
document.documentElement.addEventListener('turbo:render', calculateScrollbarWidth);
document.documentElement.addEventListener('turbo:frame-render', calculateScrollbarWidth);

// Lenis
const lenis = new Lenis();

(function raf(time) {
    lenis.raf(time);
    window.requestAnimationFrame(raf);
    return raf;
})();

// Expose Lenis
window.lenis = lenis;

document.documentElement.addEventListener('turbo:render', () => lenis.resize());
document.documentElement.addEventListener('turbo:frame-render', () => lenis.resize());

(function menuRaf(time) {
    const narr = document.querySelector('.mod_article.article--top-creators-2025-narrative');
    const jury = document.querySelector('.mod_article.article--top-creators-2025-jury');

    if (narr && jury) {
        let ub = narr.getBoundingClientRect();
        let lb = jury.getBoundingClientRect();

        if (window.innerWidth >= 1000) {
            ub = lb;
        }

        if (ub.top < window.innerHeight * 0.75 && (lb.top + lb.height) > window.innerHeight * 0.25) {
            document.body.classList.add('top-creators-2025-blur');
        } else {
            document.body.classList.remove('top-creators-2025-blur');
        }
    }

    const menu = document.getElementById('top-creators-2025-menu');

    if (menu) {
        const links = menu.querySelectorAll('a[href*="#"]');
        let activeLink = null;

        links.forEach((link) => {
            const url = new URL(link.href);

            if (!url.hash) {
                return;
            }

            const article = document.getElementById(url.hash.substring(1));

            if (article && article.getBoundingClientRect().top <= window.innerHeight * 0.5) {
                activeLink = link;
            }
        });

        if (!activeLink) {
            links.forEach(link => link.classList.remove('active'));
        } else {
            if (!activeLink.classList.contains('active')) {
                links.forEach(link => link.classList.remove('active'));
                activeLink.classList.add('active');
            }
        }
    }

    window.requestAnimationFrame(menuRaf);
    return menuRaf;
})();

const termsClick = () => {
    for (const link of document.querySelectorAll('a[href*="#terms"]')) {
        link.addEventListener('click', (e) => {
            e.preventDefault();

            for (const wrapper of document.querySelectorAll('.top-creators-2025-terms')) {
                wrapper.classList.toggle('show');
                lenis.resize();
            }
        });
    }
};

const competitionClick = () => {
    for (const checkbox of document.querySelectorAll('#top-creators-2025-community-voting-competition-checkbox')) {
        checkbox.addEventListener('change', (e) => {
            e.preventDefault();

            for (const wrapper of document.querySelectorAll('.top-creators-2025-competition-form')) {
                if (checkbox.checked) {
                    wrapper.classList.add('show');
                } else {
                    wrapper.classList.remove('show');
                }

                lenis.resize();
            }
        });
    }
}

if ('loading' === document.readyState) {
    document.addEventListener('DOMContentLoaded', termsClick); 
    document.addEventListener('DOMContentLoaded', competitionClick); 
} else {
    termsClick();
    competitionClick();
}
